{
  "version": 1,
  "asset_id": "354f92cb-71eb-49d3-9448-ce0cc9e9918c",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/354f92cb-71eb-49d3-9448-ce0cc9e9918c/raindrop-overview.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/354f92cb-71eb-49d3-9448-ce0cc9e9918c/raindrop-overview.mp4",
  "original_filename": "raindrop-overview.mp4",
  "size": 11186440,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:14:05Z"
}
